import React from 'react';

export default function RangeSelect({ range, value, onChange, type }) {
    const timestamp = Date.now(); // Obtém o timestamp atual

    const formatarOpcoes = (range) => {
        const opcoes = new Set(); // Usa Set para evitar duplicados
        try {
            // Divida o range pelo delimitador `||`
            const ranges = range.split('||').map((r) => JSON.parse(r));

            // Combine os valores de todos os ranges
            ranges.forEach((parsedRange) => {
                if (parsedRange["Até"]) {
                    parsedRange["Até"].forEach((peso) => {
                        opcoes.add(JSON.stringify({ value: peso, label: `Até ${peso} ${type}` }));
                    });
                }
                if (parsedRange["Acima de"]) {
                    parsedRange["Acima de"].forEach((peso) => {
                        opcoes.add(JSON.stringify({ value: `${peso}+`, label: `Acima de ${peso} ${type}` }));
                    });
                }
            });
        } catch (error) {
            console.error("Erro ao analisar o range:", error);
        }

        // Converte o Set de volta para um array de objetos
        return Array.from(opcoes).map((item) => JSON.parse(item));
    };

    return (
        <select className="form-control" value={value} onChange={(e) => onChange(e.target.value)}>
            <option value="">::Selecione::</option>
            {formatarOpcoes(range).map((option) => (
                <option key={type + option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    );
};
